/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Showcase_LedeInputs */

const en_features_showcase_lede = /** @type {(inputs: Features_Showcase_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookings, plans, payments and your clients' progress in one place, on your side and on theirs. Fewer messages, fewer spreadsheets, more training.`)
};

const pl_features_showcase_lede = /** @type {(inputs: Features_Showcase_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje, plany, płatności i postępy klientów w jednym miejscu, po Twojej i po ich stronie. Mniej wiadomości, mniej arkuszy, więcej treningów.`)
};

/**
* | output |
* | --- |
* | "Bookings, plans, payments and your clients' progress in one place, on your side and on theirs. Fewer messages, fewer spreadsheets, more training." |
*
* @param {Features_Showcase_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_showcase_lede = /** @type {((inputs?: Features_Showcase_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Showcase_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_showcase_lede(inputs)
	return en_features_showcase_lede(inputs)
});